module.exports = __webpack_public_path__ + "assets/img/蓝牙.9d18474c.png";